import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { IQueryResponse } from '@services/api';
import { ErrorHandler } from '@helper/errorHandler';
import { useCheckRxdb } from '@hooks/checkRxdb';
import { setRxdb } from '@helper/utils';
import { IFactoryVisitDetail } from '@components/factoryList';
import { usePermissionCheckForApiCallback } from '../../../authGuard';

export const useFactoryVisitList = (forceFetch = false): IQueryResponse<Array<IFactoryVisitDetail>> => {
	const { isDbChecked, shouldFetch } = useCheckRxdb('factory_visit_list');
	const { permissionForApi } = usePermissionCheckForApiCallback({ componentName: 'FactoryVisit' });
	const fetchFactoryVisitListing = async (): Promise<Array<IFactoryVisitDetail>> => {
		try {
			const response = await APIService.getData<Array<IFactoryVisitDetail>>(APICONFIG.FACTORY_VISIT_LIST, {
				limit: '0',
			});
			if (response) {
				const data = response.map((item) => {
					return {
						...item,
						id: item?.id?.toString(),
						factory_name: `${item?.factory_name}`,
					};
				});
				await setRxdb('factory_visit_list', data);
			}
			return response;
		} catch (error) {
			ErrorHandler(error);
			return [];
		}
	};

	const { data, error, isLoading, isPending, isFetching, refetch } = useQuery({
		queryKey: ['factoryVisitListing'],
		queryFn: fetchFactoryVisitListing,
		enabled: permissionForApi && ((isDbChecked && shouldFetch) || forceFetch),
		refetchOnWindowFocus: false,
		retry: false,
		staleTime: 30 * 60 * 1000,
		refetchOnMount: false,
		refetchOnReconnect: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
		refetch,
	};
};
